import React from 'react';

const CourierOrderCard = ({food, index, handleAcceptOrder}) => {
  return (
    <div className="p-3 shadow">
      <div className="fs-2 fw-bold text-center">Order {index + 1}</div>
      <div className="my-4 fw-semibold">
        <div>Restaurant Name: {food?.name}</div>
        <div>Restaurant Address: {food?.addressLine1} {food?.addressLine2}</div>
        <div>Delivery Address: {food?.address}</div>
        <div>Status: {food?.status}</div>
      </div>
      <button onClick={()=> handleAcceptOrder(food.orderId, 12)} className="w-100 rounded border-0 py-2 fw-semibold courier-btn">Accept</button>
    </div>
  );
};

export default CourierOrderCard;